/**
 * Generated from BadgePopupLayout.fla
 */
export function BadgePopupLayout(this: IBadgePopupLayout) {
	const badgeBg = this.badgeBg;
	if (!badgeBg[0] && badgeBg.elementFactory) {
		badgeBg[0] = badgeBg.elementFactory(0,undefined);
	}
	if (badgeBg[0]) {
		BadgePopupLayout_badgeBronze.call(badgeBg[0] as IBadgePopupLayout_badgeBronze);
		badgeBg[0].x = 315.55;
		badgeBg[0].y = 294;
		badgeBg[0].width = 173.00;
		badgeBg[0].height = 267.50;
		if (badgeBg[0].onLayout) badgeBg[0].onLayout();
	}
	if (!badgeBg[1] && badgeBg.elementFactory) {
		badgeBg[1] = badgeBg.elementFactory(1,undefined);
	}
	if (badgeBg[1]) {
		BadgePopupLayout_badgeGold.call(badgeBg[1] as IBadgePopupLayout_badgeGold);
		badgeBg[1].x = 513.5;
		badgeBg[1].y = 294;
		badgeBg[1].width = 173.50;
		badgeBg[1].height = 267.50;
		if (badgeBg[1].onLayout) badgeBg[1].onLayout();
	}
	if (!badgeBg[2] && badgeBg.elementFactory) {
		badgeBg[2] = badgeBg.elementFactory(2,undefined);
	}
	if (badgeBg[2]) {
		BadgePopupLayout_badgeSilver.call(badgeBg[2] as IBadgePopupLayout_badgeSilver);
		badgeBg[2].x = 711;
		badgeBg[2].y = 294;
		badgeBg[2].width = 173.00;
		badgeBg[2].height = 267.50;
		if (badgeBg[2].onLayout) badgeBg[2].onLayout();
	}
	const badgeIconDodger = this.badgeIconDodger;
	if (!badgeIconDodger[0] && badgeIconDodger.elementFactory) {
		badgeIconDodger[0] = badgeIconDodger.elementFactory(0,undefined);
	}
	if (badgeIconDodger[0]) {
		BadgePopupLayout_badgeIconDodger0.call(badgeIconDodger[0] as IBadgePopupLayout_badgeIconDodger0);
		badgeIconDodger[0].x = 315.5;
		badgeIconDodger[0].y = 241;
		badgeIconDodger[0].width = 106.50;
		badgeIconDodger[0].height = 108.00;
		if (badgeIconDodger[0].onLayout) badgeIconDodger[0].onLayout();
	}
	if (!badgeIconDodger[1] && badgeIconDodger.elementFactory) {
		badgeIconDodger[1] = badgeIconDodger.elementFactory(1,undefined);
	}
	if (badgeIconDodger[1]) {
		BadgePopupLayout_badgeIconDodger0.call(badgeIconDodger[1] as IBadgePopupLayout_badgeIconDodger0);
		badgeIconDodger[1].x = 516;
		badgeIconDodger[1].y = 241;
		badgeIconDodger[1].width = 106.50;
		badgeIconDodger[1].height = 108.00;
		if (badgeIconDodger[1].onLayout) badgeIconDodger[1].onLayout();
	}
	if (!badgeIconDodger[2] && badgeIconDodger.elementFactory) {
		badgeIconDodger[2] = badgeIconDodger.elementFactory(2,undefined);
	}
	if (badgeIconDodger[2]) {
		BadgePopupLayout_badgeIconDodger0.call(badgeIconDodger[2] as IBadgePopupLayout_badgeIconDodger0);
		badgeIconDodger[2].x = 713;
		badgeIconDodger[2].y = 241;
		badgeIconDodger[2].width = 106.50;
		badgeIconDodger[2].height = 108.00;
		if (badgeIconDodger[2].onLayout) badgeIconDodger[2].onLayout();
	}
	const badgeIconSwaptastic = this.badgeIconSwaptastic;
	if (!badgeIconSwaptastic[0] && badgeIconSwaptastic.elementFactory) {
		badgeIconSwaptastic[0] = badgeIconSwaptastic.elementFactory(0,undefined);
	}
	if (badgeIconSwaptastic[0]) {
		BadgePopupLayout_badgeIconSwaptastic0.call(badgeIconSwaptastic[0] as IBadgePopupLayout_badgeIconSwaptastic0);
		badgeIconSwaptastic[0].x = 315;
		badgeIconSwaptastic[0].y = 234;
		badgeIconSwaptastic[0].width = 139.00;
		badgeIconSwaptastic[0].height = 115.50;
		if (badgeIconSwaptastic[0].onLayout) badgeIconSwaptastic[0].onLayout();
	}
	if (!badgeIconSwaptastic[1] && badgeIconSwaptastic.elementFactory) {
		badgeIconSwaptastic[1] = badgeIconSwaptastic.elementFactory(1,undefined);
	}
	if (badgeIconSwaptastic[1]) {
		BadgePopupLayout_badgeIconSwaptastic0.call(badgeIconSwaptastic[1] as IBadgePopupLayout_badgeIconSwaptastic0);
		badgeIconSwaptastic[1].x = 515.5;
		badgeIconSwaptastic[1].y = 234;
		badgeIconSwaptastic[1].width = 139.00;
		badgeIconSwaptastic[1].height = 115.50;
		if (badgeIconSwaptastic[1].onLayout) badgeIconSwaptastic[1].onLayout();
	}
	if (!badgeIconSwaptastic[2] && badgeIconSwaptastic.elementFactory) {
		badgeIconSwaptastic[2] = badgeIconSwaptastic.elementFactory(2,undefined);
	}
	if (badgeIconSwaptastic[2]) {
		BadgePopupLayout_badgeIconSwaptastic0.call(badgeIconSwaptastic[2] as IBadgePopupLayout_badgeIconSwaptastic0);
		badgeIconSwaptastic[2].x = 712.5;
		badgeIconSwaptastic[2].y = 234;
		badgeIconSwaptastic[2].width = 139.00;
		badgeIconSwaptastic[2].height = 115.50;
		if (badgeIconSwaptastic[2].onLayout) badgeIconSwaptastic[2].onLayout();
	}
	const badgeIconPerfectPond = this.badgeIconPerfectPond;
	if (!badgeIconPerfectPond[0] && badgeIconPerfectPond.elementFactory) {
		badgeIconPerfectPond[0] = badgeIconPerfectPond.elementFactory(0,undefined);
	}
	if (badgeIconPerfectPond[0]) {
		BadgePopupLayout_badgeIconPerfectPond0.call(badgeIconPerfectPond[0] as IBadgePopupLayout_badgeIconPerfectPond0);
		badgeIconPerfectPond[0].x = 315;
		badgeIconPerfectPond[0].y = 234;
		badgeIconPerfectPond[0].width = 105.50;
		badgeIconPerfectPond[0].height = 138.50;
		if (badgeIconPerfectPond[0].onLayout) badgeIconPerfectPond[0].onLayout();
	}
	if (!badgeIconPerfectPond[1] && badgeIconPerfectPond.elementFactory) {
		badgeIconPerfectPond[1] = badgeIconPerfectPond.elementFactory(1,undefined);
	}
	if (badgeIconPerfectPond[1]) {
		BadgePopupLayout_badgeIconPerfectPond0.call(badgeIconPerfectPond[1] as IBadgePopupLayout_badgeIconPerfectPond0);
		badgeIconPerfectPond[1].x = 515.5;
		badgeIconPerfectPond[1].y = 234;
		badgeIconPerfectPond[1].width = 105.50;
		badgeIconPerfectPond[1].height = 138.50;
		if (badgeIconPerfectPond[1].onLayout) badgeIconPerfectPond[1].onLayout();
	}
	if (!badgeIconPerfectPond[2] && badgeIconPerfectPond.elementFactory) {
		badgeIconPerfectPond[2] = badgeIconPerfectPond.elementFactory(2,undefined);
	}
	if (badgeIconPerfectPond[2]) {
		BadgePopupLayout_badgeIconPerfectPond0.call(badgeIconPerfectPond[2] as IBadgePopupLayout_badgeIconPerfectPond0);
		badgeIconPerfectPond[2].x = 712.5;
		badgeIconPerfectPond[2].y = 234;
		badgeIconPerfectPond[2].width = 105.50;
		badgeIconPerfectPond[2].height = 138.50;
		if (badgeIconPerfectPond[2].onLayout) badgeIconPerfectPond[2].onLayout();
	}
	const badgeIconMeetTheDucks = this.badgeIconMeetTheDucks;
	if (!badgeIconMeetTheDucks[0] && badgeIconMeetTheDucks.elementFactory) {
		badgeIconMeetTheDucks[0] = badgeIconMeetTheDucks.elementFactory(0,undefined);
	}
	if (badgeIconMeetTheDucks[0]) {
		BadgePopupLayout_badgeIconMeetTheDucks0.call(badgeIconMeetTheDucks[0] as IBadgePopupLayout_badgeIconMeetTheDucks0);
		badgeIconMeetTheDucks[0].x = 315;
		badgeIconMeetTheDucks[0].y = 234;
		badgeIconMeetTheDucks[0].width = 130.00;
		badgeIconMeetTheDucks[0].height = 110.00;
		if (badgeIconMeetTheDucks[0].onLayout) badgeIconMeetTheDucks[0].onLayout();
	}
	if (!badgeIconMeetTheDucks[1] && badgeIconMeetTheDucks.elementFactory) {
		badgeIconMeetTheDucks[1] = badgeIconMeetTheDucks.elementFactory(1,undefined);
	}
	if (badgeIconMeetTheDucks[1]) {
		BadgePopupLayout_badgeIconMeetTheDucks0.call(badgeIconMeetTheDucks[1] as IBadgePopupLayout_badgeIconMeetTheDucks0);
		badgeIconMeetTheDucks[1].x = 515.5;
		badgeIconMeetTheDucks[1].y = 234;
		badgeIconMeetTheDucks[1].width = 130.00;
		badgeIconMeetTheDucks[1].height = 110.00;
		if (badgeIconMeetTheDucks[1].onLayout) badgeIconMeetTheDucks[1].onLayout();
	}
	if (!badgeIconMeetTheDucks[2] && badgeIconMeetTheDucks.elementFactory) {
		badgeIconMeetTheDucks[2] = badgeIconMeetTheDucks.elementFactory(2,undefined);
	}
	if (badgeIconMeetTheDucks[2]) {
		BadgePopupLayout_badgeIconMeetTheDucks0.call(badgeIconMeetTheDucks[2] as IBadgePopupLayout_badgeIconMeetTheDucks0);
		badgeIconMeetTheDucks[2].x = 712.5;
		badgeIconMeetTheDucks[2].y = 234;
		badgeIconMeetTheDucks[2].width = 130.00;
		badgeIconMeetTheDucks[2].height = 110.00;
		if (badgeIconMeetTheDucks[2].onLayout) badgeIconMeetTheDucks[2].onLayout();
	}
	const badgeIconFrequentFlyer = this.badgeIconFrequentFlyer;
	if (!badgeIconFrequentFlyer[0] && badgeIconFrequentFlyer.elementFactory) {
		badgeIconFrequentFlyer[0] = badgeIconFrequentFlyer.elementFactory(0,undefined);
	}
	if (badgeIconFrequentFlyer[0]) {
		BadgePopupLayout_badgeIconFrequentFlyer0.call(badgeIconFrequentFlyer[0] as IBadgePopupLayout_badgeIconFrequentFlyer0);
		badgeIconFrequentFlyer[0].x = 315;
		badgeIconFrequentFlyer[0].y = 242;
		badgeIconFrequentFlyer[0].width = 127.50;
		badgeIconFrequentFlyer[0].height = 105.00;
		if (badgeIconFrequentFlyer[0].onLayout) badgeIconFrequentFlyer[0].onLayout();
	}
	if (!badgeIconFrequentFlyer[1] && badgeIconFrequentFlyer.elementFactory) {
		badgeIconFrequentFlyer[1] = badgeIconFrequentFlyer.elementFactory(1,undefined);
	}
	if (badgeIconFrequentFlyer[1]) {
		BadgePopupLayout_badgeIconFrequentFlyer0.call(badgeIconFrequentFlyer[1] as IBadgePopupLayout_badgeIconFrequentFlyer0);
		badgeIconFrequentFlyer[1].x = 515.5;
		badgeIconFrequentFlyer[1].y = 242;
		badgeIconFrequentFlyer[1].width = 127.50;
		badgeIconFrequentFlyer[1].height = 105.00;
		if (badgeIconFrequentFlyer[1].onLayout) badgeIconFrequentFlyer[1].onLayout();
	}
	if (!badgeIconFrequentFlyer[2] && badgeIconFrequentFlyer.elementFactory) {
		badgeIconFrequentFlyer[2] = badgeIconFrequentFlyer.elementFactory(2,undefined);
	}
	if (badgeIconFrequentFlyer[2]) {
		BadgePopupLayout_badgeIconFrequentFlyer0.call(badgeIconFrequentFlyer[2] as IBadgePopupLayout_badgeIconFrequentFlyer0);
		badgeIconFrequentFlyer[2].x = 712.5;
		badgeIconFrequentFlyer[2].y = 242;
		badgeIconFrequentFlyer[2].width = 127.50;
		badgeIconFrequentFlyer[2].height = 105.00;
		if (badgeIconFrequentFlyer[2].onLayout) badgeIconFrequentFlyer[2].onLayout();
	}
	const badgeIconFirstFlight = this.badgeIconFirstFlight;
	if (!badgeIconFirstFlight[0] && badgeIconFirstFlight.elementFactory) {
		badgeIconFirstFlight[0] = badgeIconFirstFlight.elementFactory(0,undefined);
	}
	if (badgeIconFirstFlight[0]) {
		BadgePopupLayout_badgeIconFirstFlight0.call(badgeIconFirstFlight[0] as IBadgePopupLayout_badgeIconFirstFlight0);
		badgeIconFirstFlight[0].x = 315;
		badgeIconFirstFlight[0].y = 234;
		badgeIconFirstFlight[0].width = 82.50;
		badgeIconFirstFlight[0].height = 123.50;
		if (badgeIconFirstFlight[0].onLayout) badgeIconFirstFlight[0].onLayout();
	}
	if (!badgeIconFirstFlight[1] && badgeIconFirstFlight.elementFactory) {
		badgeIconFirstFlight[1] = badgeIconFirstFlight.elementFactory(1,undefined);
	}
	if (badgeIconFirstFlight[1]) {
		BadgePopupLayout_badgeIconFirstFlight0.call(badgeIconFirstFlight[1] as IBadgePopupLayout_badgeIconFirstFlight0);
		badgeIconFirstFlight[1].x = 515.5;
		badgeIconFirstFlight[1].y = 234;
		badgeIconFirstFlight[1].width = 82.50;
		badgeIconFirstFlight[1].height = 123.50;
		if (badgeIconFirstFlight[1].onLayout) badgeIconFirstFlight[1].onLayout();
	}
	if (!badgeIconFirstFlight[2] && badgeIconFirstFlight.elementFactory) {
		badgeIconFirstFlight[2] = badgeIconFirstFlight.elementFactory(2,undefined);
	}
	if (badgeIconFirstFlight[2]) {
		BadgePopupLayout_badgeIconFirstFlight0.call(badgeIconFirstFlight[2] as IBadgePopupLayout_badgeIconFirstFlight0);
		badgeIconFirstFlight[2].x = 712.5;
		badgeIconFirstFlight[2].y = 234;
		badgeIconFirstFlight[2].width = 82.50;
		badgeIconFirstFlight[2].height = 123.50;
		if (badgeIconFirstFlight[2].onLayout) badgeIconFirstFlight[2].onLayout();
	}
	const bg = this.bg;
	BadgePopupLayout_bg.call(this.bg);
	bg.x = 515;
	bg.y = 347.5;
	bg.width = 721.99;
	bg.height = 531.68;
	if (bg.onLayout) bg.onLayout();
	const continueButton = this.continueButton;
	BadgePopupLayout_continueButton.call(this.continueButton);
	continueButton.x = 512;
	continueButton.y = 573.1;
	continueButton.width = 188.00;
	continueButton.height = 114.50;
	if (continueButton.onLayout) continueButton.onLayout();
	const badge1Description = this.badge1Description;
	badge1Description.x = 233;
	badge1Description.y = 439;
	badge1Description.textAreaWidth = 167.00;
	badge1Description.textAreaHeight = 92.00;
	badge1Description.fontSize = 30;
	if (badge1Description.onLayout) badge1Description.onLayout();
	const badge2Description = this.badge2Description;
	badge2Description.x = 430;
	badge2Description.y = 439;
	badge2Description.textAreaWidth = 167.00;
	badge2Description.textAreaHeight = 92.00;
	badge2Description.fontSize = 30;
	if (badge2Description.onLayout) badge2Description.onLayout();
	const badge3Description = this.badge3Description;
	badge3Description.x = 628;
	badge3Description.y = 439;
	badge3Description.textAreaWidth = 167.00;
	badge3Description.textAreaHeight = 92.00;
	badge3Description.fontSize = 30;
	if (badge3Description.onLayout) badge3Description.onLayout();
	const dwellToggleButton = this.dwellToggleButton;
	BadgePopupLayout_dwellToggleButton.call(this.dwellToggleButton);
	dwellToggleButton.x = 1014.55;
	dwellToggleButton.y = 112.05;
	dwellToggleButton.width = 103.26;
	dwellToggleButton.height = 58.28;
	if (dwellToggleButton.onLayout) dwellToggleButton.onLayout();
	const homeButton = this.homeButton;
	BadgePopupLayout_homeButton.call(this.homeButton);
	homeButton.x = 9;
	homeButton.y = 72.8;
	homeButton.width = 85.50;
	homeButton.height = 90.90;
	if (homeButton.onLayout) homeButton.onLayout();
	return this;
}
function BadgePopupLayout_bg(this: IBadgePopupLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-modal.png", 0.500, 0.500);
	return this;
}
function BadgePopupLayout_continueButton(this: IBadgePopupLayout_continueButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-btn-done.png", 0.503, 0.271);
	return this;
}
function BadgePopupLayout_badgeBronze(this: IBadgePopupLayout_badgeBronze) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-bronze.png", 0.500, 0.500);
	return this;
}
function BadgePopupLayout_badgeGold(this: IBadgePopupLayout_badgeGold) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-gold.png", 0.500, 0.500);
	return this;
}
function BadgePopupLayout_badgeSilver(this: IBadgePopupLayout_badgeSilver) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-silver.png", 0.500, 0.500);
	return this;
}
function BadgePopupLayout_badgeIconDodger0(this: IBadgePopupLayout_badgeIconDodger0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-greatdodger.png", 0.500, 0.206);
	return this;
}
function BadgePopupLayout_badgeIconSwaptastic0(this: IBadgePopupLayout_badgeIconSwaptastic0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-swaptastic.png", 0.507, 0.316);
	return this;
}
function BadgePopupLayout_badgeIconPerfectPond0(this: IBadgePopupLayout_badgeIconPerfectPond0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-perfectpond.png", 0.512, 0.300);
	return this;
}
function BadgePopupLayout_badgeIconMeetTheDucks0(this: IBadgePopupLayout_badgeIconMeetTheDucks0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-meettheducks.png", 0.496, 0.195);
	return this;
}
function BadgePopupLayout_badgeIconFrequentFlyer0(this: IBadgePopupLayout_badgeIconFrequentFlyer0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-frequentflyer.png", 0.494, 0.193);
	return this;
}
function BadgePopupLayout_badgeIconFirstFlight0(this: IBadgePopupLayout_badgeIconFirstFlight0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-badges-icon-firstflight.png", 0.452, 0.265);
	return this;
}
function BadgePopupLayout_dwellToggleButton(this: IBadgePopupLayout_dwellToggleButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-dwell-off-btn.png", 1.000, 0.000);
	return this;
}
function BadgePopupLayout_homeButton(this: IBadgePopupLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-home-btn-large.png", 0.000, 0.000);
	return this;
}
interface IBadgePopupLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBadgePopupLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBadgePopupLayoutSprite extends IBadgePopupLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBadgePopupLayoutText extends IBadgePopupLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBadgePopupLayoutPolygon extends Array<number> {
}
interface IBadgePopupLayout {
	readonly badgeBg: IBadgePopupLayoutArray<IBadgePopupLayout_badgeBronze|IBadgePopupLayout_badgeGold|IBadgePopupLayout_badgeSilver>;
	readonly badgeIconDodger: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconDodger0>;
	readonly badgeIconSwaptastic: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconSwaptastic0>;
	readonly badgeIconPerfectPond: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconPerfectPond0>;
	readonly badgeIconMeetTheDucks: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconMeetTheDucks0>;
	readonly badgeIconFrequentFlyer: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconFrequentFlyer0>;
	readonly badgeIconFirstFlight: IBadgePopupLayoutArray<IBadgePopupLayout_badgeIconFirstFlight0>;
	readonly bg: IBadgePopupLayout_bg;
	readonly continueButton: IBadgePopupLayout_continueButton;
	readonly badge1Description: IBadgePopupLayoutText;
	readonly badge2Description: IBadgePopupLayoutText;
	readonly badge3Description: IBadgePopupLayoutText;
	readonly dwellToggleButton: IBadgePopupLayout_dwellToggleButton;
	readonly homeButton: IBadgePopupLayout_homeButton;
}
interface IBadgePopupLayout_bg extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_continueButton extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeBronze extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeGold extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeSilver extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconDodger0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconSwaptastic0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconPerfectPond0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconMeetTheDucks0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconFrequentFlyer0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_badgeIconFirstFlight0 extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_dwellToggleButton extends IBadgePopupLayoutSprite {
}
interface IBadgePopupLayout_homeButton extends IBadgePopupLayoutSprite {
}
